import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg navbar-light",
  id: "Footer"
}
const _hoisted_2 = { class: "container-fluid pt-5 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_3 = { class: "top col-12 d-flex flex-column flex-lg-row justify-content-center align-items-center" }
const _hoisted_4 = { class: "left col-12 col-lg-3 d-flex flex-row justify-content-center align-items-center" }
const _hoisted_5 = {
  class: "logo d-flex flex-row justify-content-center align-items-center",
  href: "https://ine.mx",
  target: "_blank"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "middle col-6 col-lg-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu pt-4 row d-flex flex-row justify-content-center justify-content-lg-start align-items-center" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "col-6 col-lg-4 text-center text-lg-start",
      "data-bs-target": "#surveyModal",
      "data-bs-toggle": "modal",
      style: {"cursor":"pointer"}
    }, "Encuesta de opinión"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "col-6 col-lg-4 text-center text-lg-start",
      href: "#"
    }, "Mapa del sitio")
  ])
], -1)
const _hoisted_8 = { class: "right col-6 col-lg-2 mt-3 mt-0 d-flex flex-row justify-content-center justify-content-lg-start align-items-center" }
const _hoisted_9 = {
  href: "https://facebook.com/INEMexico",
  target: "_blank"
}
const _hoisted_10 = {
  href: "https://twitter.com/INEMexico",
  target: "_blank"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"sub col-12 d-flex flex-row justify-content-center align-items-center\"><div class=\"col-lg-2\"></div><div class=\"disclaimer col-11 col-lg-8 pt-4 pb-3 row d-flex flex-row justify-content-start justify-content-lg-center align-items-center\"><div class=\"col-12 px-0 col-sm-6\"><p class=\"fw-bold\">Plataforma de Visualización de Resultados Informe País 2020</p><p class=\"mb-0\">Derechos Reservados © 2021</p><p class=\"mb-0\">Programa de las Naciones Unidas para el Desarrollo (PNUD)</p><p class=\"mb-0\">Montes Urales 440 Col. Lomas de Chapultepec, Miguel Hidalgo</p><p class=\"mb-0\">C.P. 11000, Ciudad de México</p></div><div class=\"col-12 px-0 col-sm-6\"><p class=\"fw-bold mb-0\">Derechos Reservados © 2021</p><p class=\"fw-bold mb-0\">Instituto Nacional Electoral (INE)</p><p class=\"fw-bold mb-0\">Viaducto Tlalpan 100</p><p class=\"fw-bold mb-0\">Col. Arenal Tepepan, Tlalpan</p><p class=\"fw-bold\">C.P. 14610, Ciudad de México</p><p class=\"fw-bold mb-1\" style=\"font-size:8px;\">Ni esta plataforma ni partes de ella pueden ser reproducidas, almacenadas mediante cualquier sistema o transmitidas, en cualquier forma o por cualquier medio, sea éste electrónico, mecánico, de fotocopiado, de grabado o de otro tipo, sin el permiso previo del INE y del PNUD.</p><p class=\"fw-bold\" style=\"font-size:8px;\">El análisis y las conclusiones aquí expresadas no reflejan necesariamente las opiniones del INE ni del PNUD, de su Junta Ejecutiva, ni de sus Estados Miembros.</p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("img", {
              class: "col-6",
              src: require(`@/assets/images/logo-ine-white.svg`)
            }, null, 8, _hoisted_6)
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_v_icon, {
              class: "me-3",
              name: "fa-facebook",
              scale: "2"
            })
          ]),
          _createElementVNode("a", _hoisted_10, [
            _createVNode(_component_v_icon, {
              class: "ms-3",
              name: "fa-twitter",
              scale: "2"
            })
          ])
        ])
      ]),
      _hoisted_11
    ])
  ]))
}